
/* START_TEMPLATE */
define('hbs!commons/templates/editorialschedule',['hbs','handlebars','templates/helpers/dateType'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n            ";
  stack1 = helpers.each.call(depth0, depth0.BookingRules, {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n            ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n            <tr>\r\n                <td>";
  if (stack1 = helpers.Position) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.Position; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n                <td>";
  if (stack1 = helpers.Days) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.Days; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n                <td>"
    + escapeExpression(((stack1 = ((stack1 = depth0.MaterialDay),stack1 == null || stack1 === false ? stack1 : stack1.Value)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " "
    + escapeExpression(((stack1 = ((stack1 = depth0.MaterialDay),stack1 == null || stack1 === false ? stack1 : stack1.Unit)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " "
    + escapeExpression(((stack1 = ((stack1 = depth0.MaterialDay),stack1 == null || stack1 === false ? stack1 : stack1.Time)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</td>\r\n                <td>"
    + escapeExpression(((stack1 = ((stack1 = depth0.BookingDay),stack1 == null || stack1 === false ? stack1 : stack1.Value)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " "
    + escapeExpression(((stack1 = ((stack1 = depth0.BookingDay),stack1 == null || stack1 === false ? stack1 : stack1.Unit)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " "
    + escapeExpression(((stack1 = ((stack1 = depth0.BookingDay),stack1 == null || stack1 === false ? stack1 : stack1.Time)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</td>\r\n                <td>"
    + escapeExpression(((stack1 = ((stack1 = depth0.CancellationDay),stack1 == null || stack1 === false ? stack1 : stack1.Value)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " "
    + escapeExpression(((stack1 = ((stack1 = depth0.CancellationDay),stack1 == null || stack1 === false ? stack1 : stack1.Unit)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + " "
    + escapeExpression(((stack1 = ((stack1 = depth0.CancellationDay),stack1 == null || stack1 === false ? stack1 : stack1.Time)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</td>\r\n            </tr>\r\n            ";
  return buffer;
  }

function program4(depth0,data) {
  
  
  return "\r\n            <tr>\r\n                <td colspan=\"5\">Inga bokningsupplysningar hittades.</td>\r\n            </tr>\r\n            ";
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n            ";
  stack1 = helpers.each.call(depth0, depth0.Editions, {hash:{},inverse:self.noop,fn:self.program(7, program7, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n            ";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\r\n            <tr>\r\n                <td>";
  if (stack1 = helpers.Number) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.Number; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n                <td>";
  if (stack1 = helpers.DateName) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.DateName; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n                <td>";
  options = {hash:{}};
  buffer += escapeExpression(((stack1 = helpers.dateType),stack1 ? stack1.call(depth0, depth0.MaterialDay, options) : helperMissing.call(depth0, "dateType", depth0.MaterialDay, options)))
    + "</td>\r\n                <td>";
  options = {hash:{}};
  buffer += escapeExpression(((stack1 = helpers.dateType),stack1 ? stack1.call(depth0, depth0.BookingDay, options) : helperMissing.call(depth0, "dateType", depth0.BookingDay, options)))
    + "</td>\r\n                <td>";
  options = {hash:{}};
  buffer += escapeExpression(((stack1 = helpers.dateType),stack1 ? stack1.call(depth0, depth0.CancellationDay, options) : helperMissing.call(depth0, "dateType", depth0.CancellationDay, options)))
    + "</td>\r\n                <td>";
  if (stack2 = helpers.Name) { stack2 = stack2.call(depth0, {hash:{}}); }
  else { stack2 = depth0.Name; stack2 = typeof stack2 === functionType ? stack2.apply(depth0) : stack2; }
  buffer += escapeExpression(stack2)
    + "</td>\r\n            </tr>\r\n            ";
  return buffer;
  }

function program9(depth0,data) {
  
  
  return "\r\n            <tr>\r\n                <td colspan=\"6\">Inga utgivningsdagar hittades.</td>\r\n            </tr>\r\n            ";
  }

  buffer += "<div class=\"table\">\r\n    <div class=\"table-title\"><span>Bokningsupplysningar</span></div>\r\n    <div class=\"table-content\">\r\n        <table>\r\n            <tr>\r\n                <th>Placering</th>\r\n                <th>Införandedag</th>\r\n                <th>Materialdag</th>\r\n                <th>Bokningsdag</th>\r\n                <th>Avbokningsdag</th>\r\n            </tr>\r\n            ";
  stack1 = helpers['if'].call(depth0, depth0.BookingRules, {hash:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n        </table>\r\n    </div>\r\n</div>\r\n<div class=\"table\">\r\n    <div class=\"table-title\"><span>Utgivningsplan</span></div>\r\n    <div class=\"table-content\">\r\n        <table>\r\n            <tr>\r\n                <th>Nr</th>\r\n                <th>Utgivningsdag</th>\r\n                <th>Materialdag</th>\r\n                <th>Bokningsdag</th>\r\n                <th>Avbokningsdag</th>\r\n                <th>Namn</th>\r\n            </tr>\r\n            ";
  stack1 = helpers['if'].call(depth0, depth0.Editions, {hash:{},inverse:self.program(9, program9, data),fn:self.program(6, program6, data)});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\r\n        </table>    \r\n    </div>\r\n</div>\r\n";
  return buffer;
  });
Handlebars.registerPartial('commons_templates_editorialschedule', t);
return t;
});
/* END_TEMPLATE */
;
